<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Murais
    </v-col>
    <template v-if="groups">
      <v-col cols="12" md="4" v-for="group in groups" :key="`group-${group.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text">
            <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Mural: {{ group.syllabus.course.name }} » {{ group.name }}
          </v-card-subtitle>
          <v-card-text>
            <div class="annotation" v-html="group.annotations"/>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      Não há anotações disponíveis
    </template>
  </v-row>
</template>

<script>
import { Course } from '@/services/resources'

export default {
  name: 'Annotations',
  data () {
    return {
      groups: null
    }
  },
  mounted () {
    Course.groups()
      .then(response => {
        this.groups = response.data.groups
      })
      .catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })
  }
}
</script>

<style>
.annotation img {
  max-width: 100% !important;
}
</style>
